import { api } from "../client";

export const getTimelogReport = (startDate, endDate, skip, take, sortColumn, sortDir, search) => {
  const params = new URLSearchParams({ startDate, endDate, skip, take, sortColumn, sortDir });
  if (search) params.append("search", search);
  return api.get(`/timelog-report?${params}`);
};
